export enum PaytronixCheckNumberSource {
  Bite = 'bite',
  Pos = 'pos',
}
